import styled from "styled-components";

const GUTTER_PX = 24;

export const GridContainer = styled.div`
  width: 100%;
  margin: 0 auto;

  @media (min-width: 1920px) {
    max-width: 1920px;
  }

  @media (min-width: 1440px) and (max-width: 1919px) {
    max-width: 1440px;
  }

  @media (min-width: 1200px) and (max-width: 1439px) {
    max-width: 960px;
  }

  @media (min-width: 1024px) and (max-width: 1199px) {
    max-width: 896px;
  }

  @media (min-width: 768px) and (max-width: 1023px) {
    max-width: 688px;
  }

  @media (min-width: 480px) and (max-width: 767px) {
    max-width: 432px;
  }

  @media (max-width: 479px) {
    width: calc(100% - ${GUTTER_PX * 2}px);
    max-width: 432px;
  }

  @media (max-width: 439px) {
    width: calc(100% - ${GUTTER_PX * 2}px);
    max-width: 320px;
  }
`;

export const Grid = styled.div`
  display: grid;
  column-gap: ${GUTTER_PX}px;
  row-gap: ${GUTTER_PX}px;
  grid-template-columns: repeat(4, minmax(0, 1fr));

  @media (min-width: 768px) {
    grid-template-columns: repeat(8, minmax(0, 1fr));
  }

  @media (min-width: 1024px) {
    grid-template-columns: repeat(12, minmax(0, 1fr));
  }
`;
